<template>
  <div class="flight-choice-grid">
    <section v-for="side in sides" :key="side.key" class="flight-choice">
      <h4>{{ side.label }}</h4>
      <v-autocomplete :value="choice(side.key)" :items="options(side.key)" :label="side.label + ' auswählen'" :disabled="disabled" :menu-props="{ maxWidth: 'calc(100vw - 2rem)' }" no-data-text="Kein passender Flug gefunden." outlined hide-details="auto" @change="select(side.key, $event)">
        <template v-slot:item="{ item, attrs, on }"><v-list-item v-bind="attrs" v-on="on"><v-list-item-content><v-list-item-title class="flight-choice-option">{{ item.text }}</v-list-item-title></v-list-item-content></v-list-item></template>
      </v-autocomplete>
      <p v-if="choice(side.key) !== 'custom'" class="flight-choice-summary" :class="{ 'flight-choice-warning': resolved(side.key).missing }">
        <template v-if="choice(side.key) === 'booking'">Aus dieser Buchung: </template>
        {{ resolved(side.key).missing ? 'Dieser Flug ist nicht verfügbar. Bitte neu zuordnen.' : resolved(side.key).ref ? summary(resolved(side.key).flight) : 'Noch kein Flug hinterlegt.' }}
      </p>
      <alibey-flight-fields v-if="choice(side.key) === 'custom' && value.flights" :value="value.flights" :side="side.key" />
    </section>
  </div>
</template>

<script>
import AlibeyFlightFields from "./AlibeyFlightFields.vue"
import { flightSides, flightChoice, resolveFlight, flightSummary, emptyFlights } from "./alibeyBookingView"
export default {
  name: "AlibeyFlightChoice",
  components: { AlibeyFlightFields },
  props: { value: { type: Object, required: true }, booking: { type: Object, default: null }, catalog: { type: Array, default: () => [] }, disabled: Boolean },
  data: () => ({ sides: flightSides }),
  methods: {
    summary: flightSummary,
    choice(side) { return flightChoice(this.value, side, !!this.booking) },
    resolved(side) { return resolveFlight(this.booking || this.value, this.booking ? this.value : null, side, this.catalog) },
    options(side) {
      const selected = this.choice(side)
      const choices = this.catalog.filter(item => item.side === side && (item.active || item.id === selected)).sort((a, b) => a.flight.date.localeCompare(b.flight.date) || a.flight.departure.localeCompare(b.flight.departure)).map(item => ({ text: flightSummary(item.flight) + (item.active ? "" : " · Archiviert"), value: item.id }))
      if (selected && !["booking", "custom"].includes(selected) && !choices.some(item => item.value === selected)) choices.push({ text: "Flug nicht verfügbar – bitte neu zuordnen", value: selected, disabled: true })
      return [...(this.booking ? [{ text: "Wie in dieser Buchung", value: "booking" }] : []), { text: "Noch nicht zugeordnet", value: "" }, ...choices, { text: "Eigene Flugdaten eintragen", value: "custom" }]
    },
    select(side, ref) {
      const refs = { outbound: this.choice("outbound"), inbound: this.choice("inbound"), [side]: ref }
      if (ref === "custom" && !this.value.flights) this.$set(this.value, "flights", emptyFlights())
      this.$set(this.value, "flightRefs", refs)
    },
  },
}
</script>

<style scoped>
.flight-choice-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; }
.flight-choice { min-width: 0; padding: 1rem; border: 1px solid rgba(255, 255, 255, .14); border-radius: .75rem; }
.flight-choice-option { white-space: normal; overflow-wrap: anywhere; font-size: 1rem; line-height: 1.5; }
h4 { font-size: 1rem; margin: 0 0 1rem; }
.flight-choice-summary { font-size: .875rem; line-height: 1.6; color: #c4c4ce; margin: .75rem 0 0; overflow-wrap: anywhere; }
.flight-choice-warning { color: #fcd34d; }
.flight-choice ::v-deep .v-select__selection { white-space: normal; overflow: visible; max-width: 100%; line-height: 1.5; font-size: 1rem; }
.flight-choice ::v-deep .v-select__selections { min-width: 0; padding-top: .75rem; padding-bottom: .75rem; }
.flight-choice ::v-deep .flight-fields { margin-top: 1rem; }
.flight-choice ::v-deep .flight-fields h4 { display: none; }
.flight-choice ::v-deep .flight-grid { grid-template-columns: minmax(0, 1fr); }
@media (max-width: 700px) { .flight-choice-grid { grid-template-columns: minmax(0, 1fr); } }
</style>
